import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useState, useEffect, Fragment } from "react";
import { IoIosArrowForward } from "react-icons/io";

import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  Typography,
  Button,
  Paper,
  Box,
  Divider,
} from "@mui/material";

import DrivingLicence from "./DrivingLicence/DrivingLicence";
import { useAxios, useAxiosV2, useComponent } from "../../hooks/";
import Aadharverificaion from "./Aadharverificaion/Aadharverificaion";
import Passport from "./Passport/Passport";

import DigiLocker from "./DigiLocker/DigiLocker";

import { Loader } from "./../../components";

import { styled } from "@mui/material/styles";
import Error from "../Error/Error";
import EventBookingSuccess from "../Success/EventBookingSuccess";
import pages from "../../constants/pages";
import aadhar from "./assests/Aadhar.svg";

import dl from "./assests/DL.svg";
import icon from "./assests/headericon.svg";
import DIGILOCKER from "./assests/DIGILOCKER.svg";
import AadharCardBack from "./assests/AadharCard.svg";
import VerificationPopup from "../user step components/VerificationPopup";
import VerificationLimitDialog from "./VerificationLimitDialog";
import { getVisitorFaceData } from "../../utils/getVisitorFaceData";

const CustomFormControl = styled(FormControl)(({ theme }) => ({
  "& .MuiOutlinedInput-root ": {
    "& fieldset": {
      borderColor: "rgb(232, 222, 207) !important",
      borderRadius: "12.5px",
    },
    "&:hover fieldset": {
      borderColor: "rgb(161, 130, 74)",
      borderRadius: "12.5px",
    },
    "&.Mui-focused fieldset": {
      borderColor: " rgb(161, 130, 74)",
      borderRadius: "12.5px",
    },
  },

  "&.MuiSelect-icon": {
    color: " rgb(161, 130, 74) !important",
  },

  "& .MuiOutlinedInput-notchedOutline ": {
    borderColor: "1px solid rgb(232, 222, 207)",
  },

  ".MuiInputLabel-root": {
    color: "rgb(161, 130, 74)",
  },
}));

const OuterBox2 = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "100%",
  boxSizing: "border-box",
  background: "#ffffff",

  [theme.breakpoints.up("sm")]: {
    width: "100%", // full width for small devices
  },
  [theme.breakpoints.up("md")]: {
    width: "700px", // tablets
  },
  [theme.breakpoints.up("lg")]: {
    width: "900px", // laptops
  },
  [theme.breakpoints.up("xl")]: {
    width: "1100px", // large desktops
  },
}));

const OuterPaper = styled(Paper)`
  width: 100%;
  padding: 20px;
  min-height: 20vh;
`;

const WelcomeScreen = ({ setAadharVerified }) => {
  const { loader } = useComponent();

  const axiosVerismart = useAxios({ baseURL: "mox_api_2" });

  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);

  const { visitorData } = useSelector((state) => state.memberDetails);
  const selectDocument = queryParams.get("select_document");
  const [openError, setOpenError] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [token, setToken] = React.useState("");
  const [verification, setVerification] = useState(true);
  const [identityType, setIdentityType] = useState(selectDocument || 1);
  const [eventDetail, setEventDetail] = useState(false);
  const [documentsList, setDocumentsList] = useState([]);
  const [selectDocuments, setSelectDocuments] = useState(selectDocument || 1);

  const [entityDetails, setEntityDetails] = useState({});
  const [verificationFailedCount, setVerificationFailedCount] =
    React.useState(0);
  const [displayMessage, setDisplayMessage] = useState(undefined);
  const [retryPopUp, setRetryPopUp] = useState(false);
  const [redirectPageLink, setRedirectPageLink] = useState("");

  const [open, setOpen] = useState(false);
  const [errorStep, setErrorStep] = useState(null);
  const [errorUrl, setErrorUrl] = useState("");
  const [stopStep, setStopStep] = useState(6);
  const [errorMsg, setErrorMsg] = useState(null);

  const entityId = queryParams.get("entity_id");
  const bookingId = queryParams.get("booking_id");
  const visitorId = queryParams.get("visitor_id");
  const userTypeID = queryParams.get("user_type_id");
  const docFace = queryParams.get("doc_face");
  const popup = queryParams.get("popup");
  const popUp = queryParams.get("popup");
  const digiLockerID = queryParams.get("id");
  const autoConsent = queryParams.get("auto_consent");
  const indepentent = queryParams.get("indepentent");
  const scope = queryParams.get("scope");

  if (bookingId !== null) {
    sessionStorage.setItem("bookingId", bookingId);
  }

  if (visitorId !== null) {
    sessionStorage.setItem("visitorId", visitorId);
  }

  if (entityId !== null) {
    sessionStorage.setItem("entityId", entityId);
  }

  const localStorageData = { ...localStorage };

  const digipassDataKey = Object.keys(localStorageData).filter((item) => {
    return (
      item.includes(visitorId) &&
      !item.includes("userPayload") &&
      !item.includes("face&docs")
    );
  });

  useEffect(() => {
    if (entityId != -1) {
      axiosVerismart({
        url: "/admin/business/entity_details?entity_id=" + entityId,
        disableRedirect: true,
        disableError: true,
      }).then((response) => {
        if (response.status) {
          setEntityDetails(response.data);
        }
      });
    }
  }, []);

  useEffect(() => {
    const digipassData = Object.keys(localStorageData).filter((item) => {
      return (
        item.includes(visitorId) &&
        !item.includes("userPayload") &&
        !item.includes("face&docs")
      );
    });

    let faceData = digipassData.filter((item) => {
      return localStorage.getItem(item);
    });

    if (digiLockerID) {
      loader.start();
      axiosVerismart({
        url: "event/govt-api/get-user-document",
        method: "POST",
        data: {
          document_type: scope,
          request_id: digiLockerID,
          visitor_id: visitorId || visitorData.ID,
          document_verification: true,
          is_encrypted_face: true,
          face_data: localStorage.getItem(faceData[0]),
          auto_consent: autoConsent,
          entity_id: entityId,
          user_type_id: userTypeID,
        },
        disableRedirect: true,
      }).then((response) => {
        if (response.status) {
          if (autoConsent == true) {
            setOpen(true);
            setStopStep(5);
            let key = visitorId;
            localStorage.setItem(key, response.data.encrypted_face_data || "");

            axiosVerismart({
              url: "event/visitor/save-consent",
              method: "POST",
              data: {
                visitor_id: visitorId,
                booking_id: bookingId,
                entity_id: entityId,
                user_type_id: userTypeID,
                face_data: response.data.encrypted_face_data,
                consent_for: ["face", "contact-details"],
              },
              disableRedirect: true,
            }).then((response) => {
              if (response.status) {
                setStopStep(6);
              }
            });
          } else {
            let key = visitorId;
            localStorage.setItem(key, response.data.encrypted_face_data || "");
            setOpen(true);
          }
        } else {
          if (response.data.next_url) {
            setOpen(true);
            setErrorStep(response.data.step);
            setErrorUrl(response.data.next_url);
            setErrorMsg(response.displayMessage);
          }

          setVerificationFailedCount((prevCount) => prevCount + 1);
        }

        loader.apiComplete();
      });
    }
  }, []);

  useEffect(() => {
    if (!visitorData.ID && !popup) {
      // navigate(pages.appointment.route);
    }
  }, []);

  useEffect(() => {
    let faceData = digipassDataKey.filter((item) => {
      return localStorage.getItem(item);
    });

    // if (popup && faceData.length > 0) {
    //   window.close();
    // }

    // if (faceData.length !== 0 && bookingId != -1) {
    //   axiosVerismart({
    //     url: `event/verify/booking-status`,
    //     method: "POST",
    //     disableRedirect: true,
    //     data: {
    //       name: "",
    //       face_data: localStorage.getItem(faceData[0]),
    //       ...(bookingId && { booking_id: bookingId }),
    //     },
    //   }).then((response) => {
    //     if (response.status) {
    //       if (!response.data.is_valid) {
    //         setOpenError(response.data);
    //       }
    //       if (response.data.is_verified) {
    //         setOpenSuccess(true);
    //       }

    //       if (response?.data?.page_link) {
    //       }

    //       setRedirectPageLink("Done");

    //       setDisplayMessage(response.message.displayMessage);
    //     } else {
    //       setOpenError(true);

    //       setDisplayMessage(response.displayMessage);
    //     }
    //   });
    // }

    if (!Boolean(entityId && userTypeID == 1 && bookingId != -1)) {
      axiosVerismart({
        url: "admin/events/event-details?event_id=" + entityId,
        method: "GET",
        customAuthToken: "9beaa95b-c59f-4ec9-bb60-5f4ee1986311",
        disableRedirect: true,
      }).then((response) => {
        if (response.status) {
          response?.data?.button_color &&
            sessionStorage.setItem("buttonColor", response.data.button_color);
          response?.data?.background_color &&
            sessionStorage.setItem(
              "buttonBackground",
              response.data.background_color
            );
          setEventDetail(response.data);
        } else {
          setOpenError(true);

          setDisplayMessage(response.displayMessage);
        }
      });
    }
  }, []);

  useEffect(() => {
    loader.start();
    axiosVerismart({
      url: "event/booking/documents?appointment_id=" + bookingId,
      disableRedirect: true,
    })
      .then((response) => {
        if (response.status) {
          setDocumentsList(response.data);
        } else {
          setOpenError(true);

          setDisplayMessage(response.displayMessage);
        }
        loader.apiComplete();
      })
      .catch((error) => {
        loader.apiComplete();
      });
  }, []);

  const handleProceed = (value) => {
    if (value === 3) {
      axiosVerismart({
        url: `/event/govt-api/get-redirect-url?type_id=${userTypeID}`,
        method: "POST",
        data: {
          user_type_id: userTypeID,
          booking_id: bookingId,
          entity_id: entityId,
          visitor_id: visitorId,
        },
      }).then((response) => {
        if (response.status) {
          window.location.replace(response.data.redirect_url);
        }
      });
    }
    setVerification(true);
  };

  const handleIdentityTypeChange = (value) => {
    setIdentityType(value);

    // handleProceed(value);
  };

  useEffect(() => {
    if (verificationFailedCount > 3) {
      setRetryPopUp(true);
    }
  }, [verificationFailedCount]);

  return (
    <Fragment>
      <Loader>
        <Grid container className="verificationOuterBox">
          {identityType == "" && (
            <Grid item container>
              <Grid item container justifyContent={"center"}>
                <Grid
                  item
                  container
                  md={12}
                  sl={6}
                  sx={{
                    justifyContent: "start",
                    alignContent: "start",
                  }}
                >
                  <OuterBox2>
                    <OuterPaper style={{ padding: "0px" }} elevation={3}>
                      <div
                        style={{
                          width: "100%",
                          position: "relative",
                          height: "35vh",
                        }}
                      >
                        <Grid
                          item
                          xs={12}
                          sx={{
                            position: "relative",
                            zIndex: "999999",
                            top: "47%",
                            left: "3%",
                          }}
                        >
                          <Typography
                            variant="h3"
                            fontWeight={900}
                            sx={{ marginTop: "7.5px" }}
                          >
                            {identityType == 1
                              ? "Verify Profile Using Aadhar"
                              : "Let’s Verify Your Profile"}
                          </Typography>
                          <Typography
                            variant="body1"
                            fontWeight={500}
                            sx={{ marginTop: "7.5px", color: "#00000099" }}
                          >
                            {identityType == 1
                              ? `Please enter your Aadhaar details to verify your profile for ${
                                  entityDetails.campus_name ||
                                  entityDetails.event_name ||
                                  entityDetails.name
                                }.`
                              : `Digipass needs to verify your profile for ${
                                  entityDetails.campus_name ||
                                  entityDetails.event_name ||
                                  entityDetails.name
                                }`}
                          </Typography>
                        </Grid>
                        <img
                          style={{
                            height: "35vh",
                            position: "absolute",
                            top: "0px",
                          }}
                          src={identityType == 1 ? AadharCardBack : icon}
                        />
                      </div>
                    </OuterPaper>
                  </OuterBox2>
                </Grid>
              </Grid>
            </Grid>
          )}

          {!Boolean(verification) && (
            <Fragment>
              <Grid item container>
                <Grid item container justifyContent={"center"}>
                  <Grid
                    item
                    container
                    md={12}
                    sl={6}
                    sx={{
                      justifyContent: "start",
                      alignContent: "start",
                    }}
                  >
                    <OuterBox2>
                      <OuterPaper style={{ padding: "0px" }} elevation={3}>
                        {
                          <Fragment>
                            <Grid
                              item
                              // sl={6}
                              padding={"25px"}
                              alignContent={"center"}
                            >
                              <form>
                                <CustomFormControl
                                  fullWidth
                                  variant="outlined"
                                  sx={{ marginBottom: "16px" }}
                                >
                                  <Grid item container>
                                    {documentsList.map((item, index) => {
                                      return (
                                        <Fragment>
                                          {item?.document_id == 3 && (
                                            <Fragment>
                                              <Grid
                                                item
                                                container
                                                sx={{
                                                  justifyContent:
                                                    "space-between",
                                                  padding: "15px",
                                                  borderRadius: "8px",
                                                  alignItems: "center",
                                                  boxShadow:
                                                    "0px 1px 4px 0px #00000033",
                                                }}
                                                onClick={() =>
                                                  handleIdentityTypeChange(3)
                                                }
                                              >
                                                {" "}
                                                <Grid
                                                  item
                                                  sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  <img
                                                    src={DIGILOCKER}
                                                    width={"65px"}
                                                    height={"35px"}
                                                  ></img>
                                                  <Typography
                                                    variant="body1"
                                                    sx={{ fontWeight: "600" }}
                                                  >
                                                    Proceed with Digilocker
                                                  </Typography>{" "}
                                                </Grid>
                                                <Grid item>
                                                  <IoIosArrowForward
                                                    fontSize={"20px"}
                                                    color="#919191"
                                                  />
                                                </Grid>
                                              </Grid>

                                              <Grid
                                                container
                                                sx={{
                                                  alignItems: "center",
                                                  justifyContent:
                                                    "space-evenly",
                                                  margin: "45px 10px 25px",
                                                }}
                                              >
                                                <Divider
                                                  sx={{
                                                    width: "20%",
                                                    height: ".95px",
                                                    background: "#0000001A",
                                                  }}
                                                />
                                                <Typography
                                                  variant="h5"
                                                  fontWeight={400}
                                                  sx={{
                                                    textAlign: "center",
                                                    color: "#00000080",
                                                  }}
                                                >
                                                  Or Verify Using
                                                </Typography>
                                                <Divider
                                                  sx={{
                                                    width: "20%",
                                                    height: ".95px",
                                                    background: "#0000001A",
                                                  }}
                                                />
                                              </Grid>
                                            </Fragment>
                                          )}
                                        </Fragment>
                                      );
                                    })}

                                    {documentsList.map((item, index) => {
                                      return (
                                        <Fragment>
                                          {item?.document_id != 3 && (
                                            <Grid
                                              item
                                              container
                                              sx={{
                                                justifyContent: "space-between",
                                                // border: "1.5px solid #00000069",
                                                padding: "15px",
                                                borderRadius: "8px",
                                                boxShadow:
                                                  "0px 1px 4px 0px #00000033",
                                                alignItems: "center",
                                                margin: "10px 0px",
                                              }}
                                              onClick={() =>
                                                handleIdentityTypeChange(
                                                  item?.document_id
                                                )
                                              }
                                            >
                                              <Grid
                                                item
                                                sx={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                }}
                                              >
                                                <img
                                                  src={
                                                    item?.document_id == 1
                                                      ? aadhar
                                                      : item?.document_id == 2
                                                      ? dl
                                                      : dl
                                                  }
                                                  width={"65px"}
                                                  height={"35px"}
                                                ></img>
                                                <Typography
                                                  variant="body1"
                                                  sx={{ fontWeight: "600" }}
                                                >
                                                  {item.name}
                                                </Typography>
                                              </Grid>
                                              <Grid item>
                                                <IoIosArrowForward
                                                  fontSize={"20px"}
                                                  color="#919191"
                                                />
                                              </Grid>
                                            </Grid>
                                          )}
                                        </Fragment>
                                      );
                                    })}
                                  </Grid>
                                </CustomFormControl>
                              </form>
                            </Grid>
                          </Fragment>
                        }
                      </OuterPaper>
                    </OuterBox2>
                  </Grid>
                </Grid>
              </Grid>
            </Fragment>
          )}

          {Boolean(identityType === 1 && verification) && (
            <Aadharverificaion
              setAadharVerified={setAadharVerified}
              token={token}
              entityId={entityId}
              OuterBox2={OuterBox2}
              OuterPaper={OuterPaper}
              visitorId={visitorId}
              entityDetails={entityDetails}
              documentsList={documentsList}
              setVerification={setVerification}
              digipassDataKey={digipassDataKey}
              setIdentityType={setIdentityType}
              verificationFailedCount={verificationFailedCount}
              setVerificationFailedCount={setVerificationFailedCount}
              handleIdentityTypeChange={handleIdentityTypeChange}
              selectDocuments={selectDocuments}
              setSelectDocuments={setSelectDocuments}
              errorUrlS={errorUrl}
            />
          )}

          {Boolean(identityType === 2 && verification) && (
            <DrivingLicence
              token={token}
              entityId={entityId}
              entityDetails={entityDetails}
              visitorId={visitorId}
              OuterBox2={OuterBox2}
              OuterPaper={OuterPaper}
              documentsList={documentsList}
              digipassDataKey={digipassDataKey}
              setIdentityType={setIdentityType}
              setVerification={setVerification}
              verificationFailedCount={verificationFailedCount}
              handleIdentityTypeChange={handleIdentityTypeChange}
              setVerificationFailedCount={setVerificationFailedCount}
              selectDocuments={selectDocuments}
              errorUrlS={errorUrl}
              setSelectDocuments={setSelectDocuments}
            />
          )}

          {Boolean(identityType === 4 && verification) && (
            <Passport
              token={token}
              entityId={entityId}
              visitorId={visitorId}
              OuterBox2={OuterBox2}
              entityDetails={entityDetails}
              OuterPaper={OuterPaper}
              documentsList={documentsList}
              digipassDataKey={digipassDataKey}
              errorUrlS={errorUrl}
              setIdentityType={setIdentityType}
              setVerification={setVerification}
              verificationFailedCount={verificationFailedCount}
              handleIdentityTypeChange={handleIdentityTypeChange}
              setVerificationFailedCount={setVerificationFailedCount}
              selectDocuments={selectDocuments}
              setSelectDocuments={setSelectDocuments}
            />
          )}

          {Boolean(identityType == 3 && verification) && (
            <DigiLocker
              token={token}
              entityId={entityId}
              visitorId={visitorId}
              OuterBox2={OuterBox2}
              entityDetails={entityDetails}
              OuterPaper={OuterPaper}
              documentsList={documentsList}
              digipassDataKey={digipassDataKey}
              setIdentityType={setIdentityType}
              setVerification={setVerification}
              verificationFailedCount={verificationFailedCount}
              handleIdentityTypeChange={handleIdentityTypeChange}
              setVerificationFailedCount={setVerificationFailedCount}
              selectDocuments={selectDocuments}
              setSelectDocuments={setSelectDocuments}
              handleDigiLockerVerification={handleProceed}
              errorUrl={errorUrl}
            />
          )}

          <Error
            open={openError}
            CloseButton={false}
            setOpen={setOpenError}
            ErrorMessage={displayMessage}
          />

          <EventBookingSuccess
            open={openSuccess}
            setOpen={setOpenSuccess}
            SuccessMessage={displayMessage}
            handleOnClick={() => {
              navigate(redirectPageLink);
            }}
            buttonContent={redirectPageLink !== "" ? "Next" : "Next Step"}
          />

          <VerificationPopup
            open={open}
            startStep={0}
            errorUrl={errorUrl}
            stopStep={stopStep}
            errorStep={errorStep}
            errorMsg={errorMsg}
            onClose={() => {
              setOpen(false);
              setErrorStep(null);
              !digiLockerID && setErrorUrl("");
              setStopStep(6);
              if (errorStep > 1) {
                setOpen(false);
              } else if (errorStep != null) {
                navigate(errorUrl);
              } else if (popUp) {
                localStorage.setItem("windowClosed", true);
                window.close();
              } else if (bookingId == -1 && docFace == "true") {
                navigate(
                  `${pages.EventSuccess.route}?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeID}`
                );
              } else if (bookingId == -1) {
                navigate(pages.Profile.route);
              } else {
                let url = "admin/profile/get-visitor-booking-status";

                let method = "POST";

                let data = {
                  visitor_id: visitorId,
                  entity_id: entityId,
                  user_type_id: userTypeID,
                  booking_id: bookingId,
                  face_data: getVisitorFaceData(visitorId),
                };

                axiosVerismart({
                  url: url,
                  disableRedirect: true,
                  method: method,
                  data: data,
                }).then((response) => {
                  if (response.status) {
                    let state = {
                      state: {
                        userData: response.data,
                      },
                    };

                    if (userTypeID == 1) {
                      navigate(
                        `${pages.Consent.route}?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeID}&auto_consent=${autoConsent}`,
                        state
                      );
                    } else if (
                      userTypeID == 3 ||
                      userTypeID == 4 ||
                      userTypeID == 6 ||
                      userTypeID == 8
                    ) {
                      navigate(
                        `${pages.Consent.route}?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeID}&auto_consent=${autoConsent}`,
                        state
                      );
                    } else if (userTypeID == 2) {
                      navigate(
                        `${
                          indepentent
                            ? pages.IndependentAppointmentSummary.route
                            : pages.AppointmentSummary.route
                        }?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeID}&auto_consent=${autoConsent}`,
                        state
                      );
                    } else if (userTypeID == 5) {
                      navigate(
                        `${pages.HotelSummary.path}?visitor_id=${visitorId}&booking_id=${bookingId}&entity_id=${entityId}&user_type_id=${userTypeID}&auto_consent=${autoConsent}`,
                        state
                      );
                    }
                  }
                });
              }
            }}
          />
        </Grid>
      </Loader>

      <VerificationLimitDialog
        retryPopUp={retryPopUp}
        setRetryPopUp={setRetryPopUp}
      />
    </Fragment>
  );
};

export default WelcomeScreen;
